import * as React from 'react';
const Admin = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 22"
		fill="none"
		{...props}
	>
		<path
			fill="#fff"
			d="M9 0 0 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V4L9 0Zm0 3.9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 7.9c2 0 6 1.09 6 3.08a7.201 7.201 0 0 1-12 0c0-1.99 4-3.08 6-3.08Z"
		/>
	</svg>
);
export default Admin;
